import { IconButton, Badge, Button, Box } from '@material-ui/core';
import React from 'react';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import clsx from 'clsx';
import useStyles from '../styles';
import { requiredLogin } from '../../../../middlewares';
import AppButton from 'components/atoms/Button';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { TranslationKey } from '../configuration';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import { Link, useHistory } from 'react-router-dom';
import NavigationConfig from 'navigation/config';
import * as CommonSelector from 'redux/reducers/gl_common_reducer/selectors';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';
import { showToastAction } from 'components/atoms/ToastMessage';
import { useDispatch } from 'react-redux';
import NavigationActions from 'redux/reducers/gl_navigation_reducer/actions';

const FavoritesButton = () => {
  const classes = useStyles({});
  const dispatch = useDispatch();
  const history = useHistory();
  const countFavorites = CommonSelector.useInterest().data?.favourites;
  const isLogin = AuthSelectors.useLogin();
  const handleClick = () => {
    if (isLogin) {
      history.push(NavigationConfig.clientAccountFavoritesPage().path);
    } else {
      showToastAction(dispatch, 'Please login before use it', 'warning');
      dispatch(NavigationActions.showUserMenuAction({ visible: true }));
    }
  };
  return (
    <Box className={classes.link} color="inherit" onClick={handleClick}>
      <AppButton
        variant="text"
        color="inherit"
        startIcon={
          <Badge badgeContent={countFavorites || 0} color="error">
            <FavoriteBorderOutlinedIcon />
          </Badge>
        }
        text={
          <TranslatedTextV2
            translationKey={`${TranslationKey}.myFavorites`}
            defaultText="My Favorites"
          />
        }
      />
    </Box>
  );
};

export default FavoritesButton;

// requiredLogin(FavoritesButton, false);
